import '../../../App.css';
import './Sculc2023.css';

const Sculc2023Program = () => {

    return (
        <div className="sculc2023-page">
            <div className="sculc2023-header-container">
                <img
                    src="/images/new-sculc-header.png"
                    alt="Header"
                    className="sculc2023-header-image"
                />  
                <h1 className="sculc2023-title">Programs</h1>
            </div>
            <div className="sculc2023-navbar">
                <div className="sculc2023-navbar-container">
                    <a href="/sculc-2023" className="sculc2023-links">Home</a>
                    <a href="/sculc-2023-program" className="sculc2023-links">Programs</a>
                    <a href="/sculc-2023-schedule" className="sculc2023-links">Schedule</a>
                    <a href="/sculc-2023-presentation" className="sculc2023-links">Presentation</a>
                    <a href="/sculc-2023-photo" className="sculc2023-links">Photos</a>
                </div>
            </div>
            <div className="sculc2023-banner">
                <p style={{ fontSize: "2em" }}>SCULC 2023 Program</p>
            </div>
            <div className="sculc2023-program-container">
                <iframe src="https://drive.google.com/file/d/16DcyfMa8C7CoTl5uZyEitaSF6H15ClXm/preview" width="100%" allow="autoplay" title="program-pdf" style={{ aspectRatio: "8/12" }}></iframe>
            </div>
            <div style={{height: "5vh"} }></div>
            
                
        </div>
    );
};

export default Sculc2023Program;
